module.exports = __webpack_public_path__ + "img/user.88849e80.svg";